import React from 'react';
import PropTypes from 'prop-types';

export default class Divider extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    rootPrefixCls: PropTypes.string,
  };

  static defaultProps = {
    // To fix keyboard UX.
    disabled: true,
  };

  render() {
    const { className = '', rootPrefixCls } = this.props;
    return <li className={`${className} ${rootPrefixCls}-item-divider`}/>;
  }
}



// WEBPACK FOOTER //
// ../src4js/pc4public/portal/_rc/_rc-menu-7.0.3/src/Divider.jsx